// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contact .list-item.value[data-v-574f0b3e]{line-height:1.2em}.contact .list-item.value span.address span[data-v-574f0b3e]:first-child:after{content:\", \"}.contact .list-item.value span.address span[data-v-574f0b3e]:last-child:after{content:\"\"}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
